import ibsStore from "../components/Stores/IbsSurveyStore";
import { toast } from "react-toastify";
import { getSurveyResponseValue } from "./General/SurveyResponsesHelper";

//import store from "./components/Stores/SurveyStore";
//import ibsStore from "./components/Stores/IbsSurveyStore"
//import { toast } from "react-toastify";

export function toggleMandateDefaults() {
    //iterate every line, check for blank spots and add number there with a star?
    if (ibsStore.isMandateDefaultsShown === true) {
        // defaults is currently being shown, clear the defaults array to remove all defaults
        ibsStore.defaultCoordinates.length = 0;
        ibsStore.isMandateDefaultsShown = false;

        toast.info("Imputed costs have been cleared.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            draggable: false,
            autoClose: 4000,
            hideProgressBar: true,
            className: "info-notif"

        });
    } else {
        // defaults are not shown yet, fill the defaults array
        ibsStore.defaultCoordinates.length = 0;
        let mandateDefaults = GetMandateDefaultsList();
        //if combined, get asset defaults too
        let assetDefaults = GetAssetsDefaultsList()
        let allDefaults = mandateDefaults.concat(assetDefaults)
        //let allDefaults = mandateDefaults;
        ibsStore.defaultCoordinates = allDefaults;
        //console.log("DEFAULTS", ibsStore.defaultCoordinates)
        toast.info("Imputed costs have been applied", {
            position: toast.POSITION.BOTTOM_RIGHT,
            draggable: false,
            autoClose: 4000,
            hideProgressBar: true,
            className: "info-notif"
        });

        ibsStore.isMandateDefaultsShown = true;
    }
}

export function refreshDefaults(rowId = null) {
    ibsStore.defaultCoordinates.length = 0;
    let mandateDefaults = GetMandateDefaultsList();
    //if combined, get asset defaults too
    let assetDefaults = GetAssetsDefaultsList()
    let allDefaults = mandateDefaults.concat(assetDefaults)
    ibsStore.defaultCoordinates = allDefaults;


}

export function GetMandateDefaultsList(rowId = null) {
    const defaults = [];
    let listOfMandates = ibsStore.mandateData;
    // defaults are not shown yet, fill the defaults array 
    for (const element of listOfMandates) {
        //match the style to the styles mapping
        let foundStyle;
        let defaultCostGeneric;
        let defaultCostCustom;
        let defaultCostUse;
        if (ibsStore.dbStylesMap) foundStyle = ibsStore.dbStylesMap?.filter(obj => { return obj.styleID == element.styleID })[0]
        //if (ibsStore.dbDefaultCosts) defaultCost = ibsStore.dbDefaultCosts?.filter(obj => { return element.assetClassID == obj.assetClassID && element.styleID == obj.styleID }) //different way to do this

        if (ibsStore.dbDefaultCosts) {
            defaultCostGeneric = ibsStore.dbDefaultCosts?.filter(obj => { return element.agrID == obj.agrIDstr })
            defaultCostCustom = ibsStore.dbDefaultCosts?.find(obj => { return element.mandateID == obj.mandateID })
            //console.log(element.agrID, defaultCostCustom, defaultCostGeneric) //)
        }

        if (defaultCostGeneric.length > 0) defaultCostGeneric = defaultCostGeneric[0]
        else defaultCostGeneric = []


        if (element.costManagerBase == null || element.costManagerBase.toString() == "") {
            if (defaultCostCustom && defaultCostCustom.costMgrBaseBps != null) {
                defaultCostUse = defaultCostCustom
            } else {
                defaultCostUse = defaultCostGeneric
            }
            let calcBPS = null;

            if (calcBPS == null || calcBPS == 0) calcBPS = defaultCostUse?.costMgrBaseBps ? defaultCostUse.costMgrBaseBps : 0;
            let currentAvgToUse = element.holdingFeeAvg;
            if (currentAvgToUse == null || currentAvgToUse == "") {
                currentAvgToUse = element.holdingNavAvg;

            }
            let defaultVal = currentAvgToUse * (calcBPS / 10);
            let msg = `{0} is an imputed cost equal to ${calcBPS?.toFixed(1)} basis points times the average holdings of {1} M. ` + (defaultCostUse.mandateID > 0 ? `The source of the imputed cost is the data from the previous year.` : `The source of the imputed cost is a CEM database median.`) + ` You can override the imputed cost by entering a value.`
            msg = isDefaultZero(defaultVal, msg, defaultCostUse.mandateID == 0)
            defaults.push({
                "qName": "costManagerBase",
                "rowID": element.rowID,
                "message": msg,
                "value": defaultVal,
                "average": currentAvgToUse,
                "genericDefault": defaultCostUse.mandateID > 0 ? false : true
            })
            //}
        }

        if (element.costManagerPerf == null || element.costManagerPerf.toString() == "") {
            if (defaultCostCustom && defaultCostCustom.costManagerPerf != null) {
                defaultCostUse = defaultCostCustom
            } else {
                defaultCostUse = defaultCostGeneric
            }
            if (element.assetClassCategoryID == 1 || element.assetClassCategoryID == 2) {
                defaults.push({
                    "qName": "costManagerPerf",
                    "rowID": element.rowID,
                    "message": "The imputed cost assumption for ‘performance fees for public mandates is that they do not apply. If they do apply, please enter a value, or 0 if no performance fees were earned this year.",
                    "value": NaN,
                    "average": 0.0,
                    "genericDefault": true
                })
            } else {
                //if (foundStyle.agrStyleID == 'FF' || foundStyle.agrStyleID == 'LP') {
                let calcBPS = defaultCostUse?.costMgrPerfBps ? defaultCostUse.costMgrPerfBps : 0;

                let defaultVal = element.holdingNavAvg * calcBPS / 10;
              let msg = "Imputed cost: Projected imputed cost set equal to " + calcBPS + " basis points times the average holdings. This imputation will be revised as more peer data becomes available for this year. Enter a value to replace this imputed cost."
                msg = isDefaultZero(defaultVal, msg, defaultCostUse.mandateID == 0)
                //console.log("yeep", defaultCost, defaultCost.mandateID, defaultCost.mandateID == 0)
                defaults.push({
                    "qName": "costManagerPerf",
                    "rowID": element.rowID,
                    "message": msg,
                    "value": defaultVal,
                    "average": element.holdingNavAvg,
                    "genericDefault": defaultCostUse.mandateID > 0 ? false : true
                })
            }

        }

        //}
        if (element.costUnderlyBase == null || element.costUnderlyBase.toString() == "") {
            if (defaultCostCustom && defaultCostCustom.costUndBaseBps != null) {
                defaultCostUse = defaultCostCustom
            } else {
                defaultCostUse = defaultCostGeneric
            }
            let averageToUse = element.holdingFeeAvg;
            if (averageToUse == "" || averageToUse == null) {
                averageToUse = element.holdingNavAvg;
            }
            let calcBPS = defaultCostUse?.costUndBaseBps ? defaultCostUse.costUndBaseBps : 0;

            var defaultVal = averageToUse * (calcBPS / 10);
            //element.costUnderlyBase = defaultVal.toFixed(2);
            let msg = `{0} is an imputed cost equal to ${defaultCostUse.costUndBaseBps} basis points times the average holdings of {1} M. ` + (defaultCostUse.mandateID > 0 ? `The source of the imputation is the data from the previous year.` : `The source of the imputation is a CEM database median.`) + ` You can override the imputed cost by entering a value.`
            msg = isDefaultZero(defaultVal, msg, defaultCostUse.mandateID == 0)
            defaults.push({
                "qName": "costUnderlyBase",
                "rowID": element.rowID,
                "message": msg,
                "value": defaultVal,
                "average": averageToUse,
                "genericDefault": defaultCostUse.mandateID > 0 ? false : true
            })
        }

        //If HoldingFeeAverage is missing, use HoldingNAVAverage instead.
        if ((element.costUnderlyPerf == null || element.costUnderlyPerf.toString() == "") && (foundStyle.agrStyleID == 'FF')) {
            if (defaultCostCustom && defaultCostCustom.costUndPerfBps != null) {
                defaultCostUse = defaultCostCustom
            } else {
                defaultCostUse = defaultCostGeneric
            }
            let calcBPS = defaultCostUse?.costUndPerfBps ? defaultCostUse.costUndPerfBps : 0;
            let defaultVal = element.holdingNavAvg * calcBPS / 10;
            let msg = "Imputed cost: Projected imputation value set equal to " + calcBPS + " basis points times the average holdings. This imputed cost will be revised as more peer data becomes available for this year. Enter a value to replace this imputed cost."
            msg = isDefaultZero(defaultVal, msg, defaultCostUse.mandateID == 0)
            defaults.push({
                "qName": "costUnderlyPerf",
                "rowID": element.rowID,
                "message": msg,
                "value": defaultVal,
                "average": element.holdingNavAvg,
                "genericDefault": defaultCostUse.mandateID > 0 ? false : true
            })
        } else if (element.costUnderlyPerf == null || element.costUnderlyPerf.toString() == "") {
            let defaultVal = 0;
            let calcBPS = defaultCostUse?.costUndPerfBps ? defaultCostUse.costUndPerfBps : 0;
            defaultVal = element.holdingNavAvg * (defaultCostUse?.costUndPerfBps / 10);
            let msg = "Imputed cost: Projected imputation value set equal to " + calcBPS + " basis points times the average holdings. This imputed cost will be revised as more peer data becomes available for this year. Enter a value to replace this imputed cost."
            msg = isDefaultZero(defaultVal, msg, defaultCostUse?.mandateID == 0)
            defaults.push({
                "qName": "costUnderlyPerf",
                "rowID": element.rowID,
                "message": msg,
                "value": defaultVal,
                "average": element.holdingNavAvg,
                "genericDefault": defaultCostUse?.mandateID > 0 ? false : true

            })
        }

    }

    return defaults;
}


//pseudocode
//check AVG Assets given
//if FeesPaidHoldingMillions not null 
//if current and last years FeesPaidHoldingMillions exist do an average
//if last years doesnt exist, just use this years #
//else, use HoldingMillions
//if current and last years FeesPaidHoldingMillions exist do an average
//if last years doesnt exist, just use this years #


//for perf, no need to do feespaid check
//use HoldingMillions
//if current and last years FeesPaidHoldingMillions exist do an average
//if last years doesnt exist, just use this years #

export function GetAssetsDefaultsList(rowId = null) {
    const defaults = [];
    let listOfAssets = ibsStore.allTableResponses["combinedAssets"];

    // defaults are not shown yet, fill the defaults array 
    for (const element of listOfAssets) {
        //match the style to the styles mapping
        let foundStyle;
        let defaultCost = [];
        if (ibsStore.dbStylesMap) foundStyle = ibsStore.dbStylesMap?.filter(obj => { return obj.styleID == element.StyleID })[0]
        //if (ibsStore.dbDefaultCosts) defaultCost = ibsStore.dbDefaultCosts?.filter(obj => { return element.AssetClassID == obj.assetClassID && element.StyleID == obj.styleID }) //different way to do this
        if (ibsStore.dbDefaultCosts) defaultCost = ibsStore.dbDefaultCosts?.filter(obj => { return element.AgrID == obj.agrIDstr }) //different way to do this
        console.log(ibsStore.dbDefaultCosts, defaultCost)
        if (defaultCost.length > 0) defaultCost = defaultCost[0]
        else defaultCost = []

        //get last years defaults
        let lyAssetEquivalent = ibsStore.lyAssetData["combinedAssets"]?.length > 0 ? ibsStore.lyAssetData["combinedAssets"]?.find(lyAsset => lyAsset.AssetClassID == element.AssetClassID) : [];
        //get this value to see if we should ever do average defaults
        let avgAssetsGiv = getSurveyResponseValue("IsAvgAssetsGiv")

        if (element.CostBaseFeesThousands == null || element.CostBaseFeesThousands.toString() == "") {
            //if this cell is empty, do the following
            let calcBPS = defaultCost ? defaultCost.costMgrBaseBps : 0;

            let currentAvgToUse = null
            if (element.FeesPaidHoldingMillions != null) {
                //if feespaid is available for this year and last year, calculate an average
                if (lyAssetEquivalent && lyAssetEquivalent.FeesPaidHoldingMillions && avgAssetsGiv == 0) {
                    currentAvgToUse = (element.FeesPaidHoldingMillions + lyAssetEquivalent.FeesPaidHoldingMillions) / 2
                } else {
                    //use the fees paid holding that seems to exist
                    currentAvgToUse = element.FeesPaidHoldingMillions
                }
            } else {
                //No FeesPaid, so if holdings millions is available for this year and last year, calculate an average
                if (element.HoldingsMillions != null && lyAssetEquivalent && lyAssetEquivalent.HoldingsMillions && avgAssetsGiv == 0) {
                    currentAvgToUse = (element.HoldingsMillions + lyAssetEquivalent.HoldingsMillions) / 2
                } else {
                    //use the holdings million value provided in the cell whether it exists or is null = 0
                    currentAvgToUse = element.HoldingsMillions
                }
            }

            let defaultVal = currentAvgToUse * (calcBPS / 10);
            let msg = `{0} is an imputed cost equal to ${calcBPS?.toFixed(1)} basis points times the average holdings of {1} M. You can override the imputation by entering a value.`
            msg = isDefaultZero(defaultVal, msg, true)

            defaults.push({
                "qName": "CostBaseFeesThousands",
                "rowID": "A" + element.RowID,
                "message": msg,
                "value": defaultVal,
                "average": currentAvgToUse,
                "genericDefault": true

            })
        }

        if (element.CostPerformanceThousands == null || element.CostPerformanceThousands.toString() == "") {
            if (element.assetClassCategoryID == 1 || element.assetClassCategoryID == 2) {
                defaults.push({
                    "qName": "CostPerformanceThousands",
                    "rowID": "A" + element.RowID,
                    "message": "The imputed assumption for ‘performance fees for public mandates is that they do not apply. If they do apply, please enter a value, or 0 if no performance fees were earned this year.",
                    "value": "N/A",
                    "average": 0.0,
                    "genericDefault": true
                })
            }

            let currentAvgToUse = null
            if (element.HoldingsMillions != null && lyAssetEquivalent && lyAssetEquivalent.HoldingsMillions != null && avgAssetsGiv == 0) {
                currentAvgToUse = (element.HoldingsMillions + lyAssetEquivalent.HoldingsMillions) / 2
            } else {
                currentAvgToUse = element.HoldingsMillions
            }
            let calcBPS = defaultCost ? defaultCost.costMgrPerfBps : 0;
            let defaultVal = currentAvgToUse * calcBPS / 10;
            let msg = "Imputed cost: Projected imputed value set equal to " + calcBPS + " basis points times the average holdings. This imputation will be revised as more peer data becomes available for this year. Enter a value to replace this imputed cost."
            msg = isDefaultZero(defaultVal, msg, true)

            defaults.push({
                "qName": "CostPerformanceThousands",
                "rowID": "A" + element.RowID,
                "message": msg,
                "value": defaultVal,
                "average": currentAvgToUse,
                "genericDefault": true
            })
        }



        if (element.UnderlyingFundFees == null || element.UnderlyingFundFees.toString() == "") {
            let currentAvgToUse = null
            if (element.FeesPaidHoldingMillions != null) {
                if (element.FeesPaidHoldingMillions == null && lyAssetEquivalent && lyAssetEquivalent.FeesPaidHoldingMillions != null && avgAssetsGiv == 0) {
                    currentAvgToUse = (element.FeesPaidHoldingMillions + lyAssetEquivalent.FeesPaidHoldingMillions) / 2
                } else {
                    currentAvgToUse = element.FeesPaidHoldingMillions
                }
            } else {
                if (element.HoldingsMillions != null && lyAssetEquivalent && lyAssetEquivalent.HoldingsMillions) {
                    currentAvgToUse = (element.HoldingsMillions + lyAssetEquivalent.HoldingsMillions) / 2
                } else {
                    currentAvgToUse = element.HoldingsMillions
                }
            }

            let calcBPS = defaultCost ? defaultCost.costUndBaseBps : 0;
            var defaultVal = currentAvgToUse * (calcBPS / 10);
            //element.costUnderlyBase = defaultVal.toFixed(2);
            let msg = `{0} is an imputed cost equal to ${calcBPS} basis points times the average holdings of {1} M. You can override the imputation by entering a value.`
            msg = isDefaultZero(defaultVal, msg, true)
            defaults.push({
                "qName": "UnderlyingFundFees",
                "rowID": "A" + element.RowID,
                "message": msg,
                "value": defaultVal,
                "average": currentAvgToUse,
                "genericDefault": true
            })
        }

        //If HoldingFeeAverage is missing, use HoldingNAVAverage instead.
        if ((element.UnderlyingPerfFees == null || element.UnderlyingPerfFees.toString() == "") && (foundStyle.agrStyleID == 'FF')) {
            let calcBPS = defaultCost ? defaultCost.costUndPerfBps : 0;
            let currentAvgToUse = null
            if (element.HoldingsMillions != null && lyAssetEquivalent && lyAssetEquivalent.HoldingsMillions && avgAssetsGiv == 0) {
                currentAvgToUse = (element.HoldingsMillions + lyAssetEquivalent.HoldingsMillions) / 2
            } else {
                currentAvgToUse = element.HoldingsMillions
            }
            let defaultVal = (currentAvgToUse * calcBPS) / 10;
            let msg = "Imputed cost: Projected imputed value set equal to " + defaultCost.costUndPerfBps + " basis points times the average holdings. This imputation will be revised as more peer data becomes available for this year. Enter a value to replace this imputed cost."
            msg = isDefaultZero(defaultVal, msg, true)
            defaults.push({
                "qName": "UnderlyingPerfFees",
                "rowID": "A" + element.RowID,
                "message": msg,
                "value": defaultVal,
                "average": currentAvgToUse,
                "genericDefault": true
            })
        } else if (element.UnderlyingPerfFees == null || element.UnderlyingPerfFees.toString() == "") {
            let calcBPS = defaultCost ? defaultCost.costUndPerfBps : 0;
            let currentAvgToUse = null
            if (lyAssetEquivalent && lyAssetEquivalent.HoldingsMillions && avgAssetsGiv == 0) {
                currentAvgToUse = (element.HoldingsMillions + lyAssetEquivalent.HoldingsMillions) / 2
            } else {
                currentAvgToUse = element.HoldingsMillions
            }
            let defaultVal = (currentAvgToUse * calcBPS) / 10;
            let msg = "Imputed cost: Projected imputed value set equal to " + defaultCost.costUndPerfBps + " basis points times the average holdings. This imputation will be revised as more peer data becomes available for this year. Enter a value to replace this imputed cost."
            msg = isDefaultZero(defaultVal, msg, true)
            defaults.push({
                "qName": "UnderlyingPerfFees",
                "rowID": "A" + element.RowID,
                "message": msg,
                "value": defaultVal,
                "average": currentAvgToUse,
                "genericDefault": true

            })
        }
        //}
    }
    return defaults;
}

const isDefaultZero = (def, msg, isGenericDefault) => {
    let message = msg
    if (def == 0 && isGenericDefault) {
        message = "No cost provided. We will assume costs of zero unless provided."
    }
    return message
}